// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"85df2a14","23":"51656576","48":"4bde263f","212":"2fe0157d","461":"10734ec7","551":"e3a3aa2e","737":"11565f3d","743":"6aa4bbb7","923":"cbd7eb3f"}[chunkId] + ".chunk.js";
};